// extracted by mini-css-extract-plugin
export default {"filters":"filter_filters__dXSHT"};